import { Theme } from '@eversports/react-components/design-tokens/theme'
import Flex from '@eversports/react-components/primitives/Flex'
import Heading from '@eversports/react-components/primitives/Heading'
import Icon from '@eversports/react-components/primitives/Icon'
import TicketIcon from '@eversports/react-components/primitives/Icon/custom-icons/Ticket'
import Text from '@eversports/react-components/primitives/Text'
import { makeStyles } from '@mui/styles'
import React from 'react'

import { Localized } from '../../../localization/react'
import Invoice from '../../../typings/Invoice'
import Venue from '../../../typings/Venue'

import Address from './Address'

const useStyles = makeStyles((theme: Theme) => ({
  heading: {
    fontSize: theme.fontSizing.large,
    [theme.breakpoints.down('md')]: {
      fontSize: theme.fontSizing.default,
    },
  },
}))

interface Props {
  venue: Venue
  invoice: Invoice
}

const InvoiceDetailsContent: React.FC<React.PropsWithChildren<Props>> = ({ venue, invoice }) => {
  const classes = useStyles()

  return (
    <div>
      <Heading is="h2" className={classes.heading} marginTop={['default', 'default', 'none']}>
        <Localized id="payment-details" />
      </Heading>
      <Text fontWeight="bold">
        <Localized id="invoice-from" params={{ venueName: venue.name }} />
      </Text>
      <Flex flexDirection="column" marginTop="wide" verticalSpacing="default">
        <Address location={venue.location!} />
        <Flex>
          <Icon icon={TicketIcon} color="subtleText" marginRight="dense" />
          <Text fontWeight="bold">
            <Localized id="invoice-number" params={{ invoiceNumber: invoice.number }} />
          </Text>
        </Flex>
      </Flex>
    </div>
  )
}

export default InvoiceDetailsContent
